import React from 'react';
import DisplayFieldProps from './Models/DisplayFieldProps';
import Dropdown from '../../../UI/Dropdown';

const BreakLineDisplayField = (props: DisplayFieldProps) => {
    const options = [
        {
            label: 'Delete',
            onClick: () => props.onDelete(props.field)
        }
    ];

    return (<div className="field-wrapper">
        <div className="row justify-content-between align-items-center">
            <div className="column">
                *New Line*
            </div>
            {!props.hideButtons && <div className="column-auto margin-top-5">
                <Dropdown disabled={props.disabled} 
                    id={`dropdown-${props.field.id}`} 
                    options={options} />
            </div>}
        </div>
        <div className="margin-vertical-3">
        <i className="ri-separator margin-start-1"></i> New Line 
        </div>
    </div>);
};

export default BreakLineDisplayField;